export default [
  {
    key: 'agent_id',
    label: 'アライアンス名',
    rules: {},
    name: 'agentId',
    as: 'select',
    options: [],
    value: null,
  },
  {
    key: 'admin_name',
    value: '',
    label: 'マネージャID',
    rules: {
      requiredWithFormat: true,
      minmax: { min: 6, max: 30 },
      adminID: true,
    },
    name: 'adminName',
    as: 'input',
  },
  {
    key: 'admin_display_name',
    value: '',
    label: 'マネージャ名',
    rules: { required: true, min: 1, max: 100 },
    name: 'adminDisplayName',
    as: 'input',
  },
  {
    key: 'password',
    value: '',
    label: 'パスワード',
    rules: {},
    name: 'password',
    as: 'input',
    type: 'password',
  },
  {
    key: 'password_2',
    value: '',
    label: 'パスワード(確認）',
    rules: {},
    name: 'passwordConfirm',
    as: 'input',
    type: 'password',
  },
  {
    key: 'level',
    label: 'マネージャタイプ',
    rules: {},
    name: 'level',
    as: 'select',
    options: [],
    value: null,
  },
]
